<template>
  <div class="crew-page">
    <!-- Start Page Title -->
    <div
      v-if="false"
      class="bg-img-div"
      v-bind:style="{ 'background-image': 'url(' + img + ') !important' }"
    />
    <div class="page-title-area">
      <div class="container">
        <div class="row">
          <div class="col-md-6 text-hero">
            <h2 class="title">
              Our Blogging Crew
            </h2>
            <p class="subtitle">
              Focused on bringing the best of what to do to the written word
            </p>
          </div>
          <div class="col-md-6">
            <lottie-animation
              :path="heroLottiePath"
              :loop="true"
              :autoPlay="true"
              :width="lottieWidth"
              :height="lottieHeight"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- End Page Title -->

    <!-- Start Crew Area -->
    <section class="crew-area ptb-80 pt-0">
      <div class="container">
        <div v-if="crewToDisplay.length > 0" class="row">
          <div
            v-for="(aCrew, index) in crewToDisplay.slice(
              start,
              start + perPage
            )"
            :key="index"
            class="col-lg-3 col-md-4 col-sm-6"
          >
            <crew-card v-if="aCrew.profile" :aCrew="aCrew" />
          </div>
        </div>
        <div v-else>
          <div v-if="!loading">
            No Crew Found
          </div>
          <div v-else>
            Loader
          </div>
        </div>
      </div>
    </section>
    <!-- End Crew Area -->
    <!-- Start Pagination Area -->
    <pagination
      v-if="totalPages > 1"
      :length="totalPages"
      @page-changed="changePage"
    />
    <!-- End Pagination Area -->
    <video-modal v-if="false" />
  </div>
</template>

<script>
import CrewCard from "@/components/other-pages/crew/CrewCard";
import Pagination from "@/components/other-pages/crew/Pagination";
import VideoModal from "@/components/other-pages/crew/VideoModal";
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"; // import lottie-vuejs
export default {
  name: "crew",
  data() {
    return {
      img: require("../../../../assets/img/guides-bg.jpg"),
      show: {
        suggestion: false
      },
      totalPages: 0,
      allCrew: [],
      crewToDisplay: [],
      searchTerm: "",
      start: 0,
      perPage: 12,
      selectedTag: null,
      lottieHeight: 500,
      lottieWidth: 500,
      loading: true
    };
  },
  components: {
    CrewCard,
    LottieAnimation,
    Pagination,
    VideoModal
  },
  mounted() {
    this.getCrew();
    this.setHeight();
    setTimeout(() => {
      this.setHeight();
    }, 1500);
    let that = this;
    (function() {
      that.setHeight();
    })();
    window.addEventListener("resize", () => {
      this.setHeight();
    });
    window.addEventListener("scroll", () => {
      this.setHeight();
    });
  },
  watch: {
    crewToDisplay(newValue, oldValue) {
      this.totalPages = Math.ceil(newValue.length / this.perPage);
    }
  },
  computed: {
    heroLottiePath() {
      //will be based on selection in the future- health, spiritual, etc
      //Cached images
      return "assets/lotties/blog-management.json";
    },
    searchedCrew() {
      let crew = [];
      if (this.searchTerm == "") {
        return crew;
      }
      let search = this.searchTerm.toLowerCase();
      this.allCrew.forEach(crew => {
        if (
          crew.user.firstname.toLowerCase().includes(search) ||
          crew.user.lastname.toLowerCase().includes(search)
        ) {
          crew.push(crew);
        }
        if (crew.profile && crew.profile.tags) {
          crew.profile.tags.forEach(tag => {
            if (tag.text.toLowerCase().includes(search)) {
              crew.push(crew);
            }
          });
        }
        if (crew.profile && crew.profile.plans) {
          crew.profile.plans.forEach(plan => {
            if (plan.details.toLowerCase().includes(search)) {
              crew.push(crew);
            }
          });
        }
      });
      const uniq = new Set(crew.map(e => JSON.stringify(e)));
      const uniqueCrew = Array.from(uniq).map(e => JSON.parse(e));
      return uniqueCrew;
    },
    heroImgPath() {
      //will be based on selection in the future- health, spiritual, etc
      //Cached images
     return null;
    }
  },
  methods: {
    getCrew() {
      this.loading = true;
      this.$store
        .dispatch("listings/getListBloggers")
        .then(res => {
          this.allCrew = res;
          this.crewToDisplay = res;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    changePage(page) {
      this.start = page * this.perPage - this.perPage;
    },
    setHeight() {
      document.querySelector(".bg-img-div").style.height =
        document.querySelector(".page-title-area").clientHeight + "px";
    },
    setCrewByTag(input) {
      if (input == "all") {
        this.crewToDisplay = this.allCrew;
      } else {
        this.crewToDisplay = [];
        this.allCrew.forEach(crew => {
          if (crew.profile && crew.profile.tags) {
            crew.profile.tags.forEach(tag => {
              if (tag.text.toLowerCase().includes(input)) {
                this.crewToDisplay.push(crew);
              }
            });
          }
        });
      }
    },
    handleCrewClick(crew) {
      this.$router.push(`/crew/${crew.profile.profileName}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.crew-page {
  .bg-img-div {
    margin-top: 120px;
    background-image: url("../../../../assets/img/guides-bg.jpg") !important;
    background-position: right bottom;
    background-repeat: no-repeat;
    background-size: contain;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
  }
  .hero-img {
    max-height: 334px;
  }
  .text-hero {
    padding-top: 60px;
    // min-height: 504px ;
    // display: flex;
    // align-items: flex-start;
    // justify-content: center;
    // flex-direction: column;
  }
  .selected-tag {
    font-weight: bold;
    font-size: large;
    color: red;
  }
  .page-title-area {
    margin-top: 125px;
    padding-top: 15px;
    padding-bottom: 0px;
    position: relative;
    background: none !important;
    .bg-img {
      display: none;
      width: 100%;
      position: absolute;
      left: 0;
      width: 100%;
      object-fit: cover;
      bottom: 0;
      object-position: right bottom;
      // ob
      z-index: -1;
    }
    .title {
      color: #52595e;
      text-align: left;
      font-size: 32px;
    }
    .subtitle {
      font-size: 16px;
      line-height: 22px;
      text-align: left;
      color: #8d99a0;
      margin: 16px 0;
      max-width: 450px;
      margin-bottom: 32px;
    }
    .tags {
      text-align: left;
      a,
      .tag {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #8d99a0;
        margin-right: 24px;
      }
      a {
        color: #557efb;
      }
    }
  }

  .crew-area {
    position: relative;
    // z-index: 2;
    // margin-top: -130px;
    margin-top: 0px;

    .sub-heading {
      margin: 24px 0;
      h3 {
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 27px;
        color: #52595e;
      }
    }

    .main-line {
      margin-top: 5px;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      color: #8d99a0;
      span {
        color: #557efb;
        text-transform: lowercase;
      }
    }
  }
  .rating {
    margin: 8px 0;
    .ico {
      margin: 0 4px;
    }
  }
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
@media (min-width: 1024px) {
  .crew-area {
    margin-top: -130px;
  }
}
</style>
